// Port of api/fuel/app/classes/model/platform/early.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'platform_early',
	prefix: 'early',
	key: 'early_id',
	fields: {
		early_id: Model.SCHEMA_KEY,
		early_status: Model.SCHEMA_NUMBER,
		early_name: Model.SCHEMA_TEXT,
		early_slug: Model.SCHEMA_TEXT,
		early_description: Model.SCHEMA_TEXT,
		early_date_added: Model.SCHEMA_TEXT,
		early_date_live: Model.SCHEMA_TEXT,
		early_image: Model.SCHEMA_TEXT,
		early_url: Model.SCHEMA_TEXT,
		early_adopted: Model.SCHEMA_JSON
	}
})
